const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

const explorationLinks = Array.from(
    document.querySelectorAll(
        '[data-photo-exploration-metric-url][data-photo-exploration-key]'
    )
);

const sendExplorationMetric = (link) => {
    const url = link.dataset.photoExplorationMetricUrl;
    const recommendationKey = link.dataset.photoExplorationKey;
    const transition = link.dataset.photoExplorationTransition;
    const semanticEffect = link.dataset.photoExplorationSemanticEffect;
    const impact = link.dataset.photoExplorationImpact;

    if (
        !url
        || !recommendationKey
        || !transition
        || !semanticEffect
        || !impact
        || !csrfToken
    ) {
        return;
    }

    const body = new FormData();
    body.append('_token', csrfToken);
    body.append('recommendation_key', recommendationKey);
    body.append('transition', transition);
    body.append('semantic_effect', semanticEffect);
    body.append('impact', impact);

    if (navigator.sendBeacon) {
        navigator.sendBeacon(url, body);
        return;
    }

    fetch(url, {
        method: 'POST',
        body,
        credentials: 'same-origin',
        keepalive: true,
        headers: {
            'Accept': 'application/json',
        },
    }).catch(() => {
        // Exploration analytics must never interfere with gallery navigation.
    });
};

explorationLinks.forEach((link) => {
    link.addEventListener('click', () => sendExplorationMetric(link), {
        capture: true,
    });
});
